export enum enumBfeeGroupBranding {
  SureCard= 1,
  Wizzit,
  mediBucks
}

export namespace enumBfeeGroupBranding {
  export function values() {
    return Object.keys(enumBfeeGroupBranding).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

